import { useWizard } from "react-use-wizard";
import { IFillDataWizardSell, TKeyOfDataWizardSell, TNumberKeysOfIFillDataWizardSell } from "../..";
import EstimateStep from "../../../../../../shared/wizard/steps/estimateStep";
import sellSteps from "../sellSteps";
import { IDataFormEstimate } from "../../../../../estimate";

interface IKnowPriceStep_7 {
  onChange: (data: Partial<IFillDataWizardSell>) => void;
  onChangePrice:  (data: number | number[], key: TNumberKeysOfIFillDataWizardSell) => void,
  onReset: (key: TKeyOfDataWizardSell[]) => void;
  isNextStepDisabled: boolean;
  dataFormEstimate: Partial<IFillDataWizardSell>;
}

const KnowPriceStep_7 = ({
  onChange,
  onReset,
  onChangePrice,
  isNextStepDisabled,
  dataFormEstimate,
}: IKnowPriceStep_7) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.knowPrice.step_6);
    onReset(["streetId", "buildingId", "areaInSqM"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.knowPrice.step_8);
  };

  const dataFormEstimateChecked = Boolean(
    dataFormEstimate.areaInSqM &&
      dataFormEstimate.buildingId &&
      dataFormEstimate.streetId
  );

  const handleEstimatePrice = (value: number) => {
    onChangePrice(value, "estimatedPrice");
  };

  return (
    <div>
      <EstimateStep
        mode="quiz"
        onEstimateForm={onChange}
        onEstimatePrice={handleEstimatePrice}
        onNexStep={handleNexStep}
        onPrevStep={handlePrevStep}
        isNextStepDisabled={isNextStepDisabled}
        dataFormEstimate={
          dataFormEstimateChecked
            ? (dataFormEstimate as IDataFormEstimate)
            : undefined
        }
      />
    </div>
  );
};

export default KnowPriceStep_7;
